exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.frhomolo-region-select-wrapper[data-v-2cf19f3b] {\n  width: 100%;\n}\n.pickerouter[data-v-2cf19f3b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: calc(100% - 44px);\n}\n.pickerinner[data-v-2cf19f3b] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n", ""]);

// exports
